/*lifelink-frontend/src/components/Footer.js*/
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; 2024 LifeLink Blood Bank Management System. All rights reserved.</p>
        <p>Save Lives - Donate Blood</p>
      </div>
    </footer>
  );
};

export default Footer;